import { observer } from 'mobx-react-lite';
import { FrPageHeader } from '../../fr-page-layout/fr-page-header';
import { useBoloPanelMetadata } from '../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { HStack, Spinner, Text, DataList, DataItem } from '@cad-arc';
import { EntityStatusIcon } from '../../entity-status-icon';

export const FrBoloPageHeader = observer(() => {
    const metadata = useBoloPanelMetadata();
    const boloId = metadata?.boloId;

    return (
        <FrPageHeader
            title={metadata?.title}
            showGoBackButton
            complementaryContent={
                boloId ? (
                    <DataList direction="row">
                        <DataItem dataKey="Creator">{metadata.creator}</DataItem>
                    </DataList>
                ) : null
            }
        >
            {boloId ? (
                <EntityStatusIcon
                    isActive={metadata?.isActive}
                    isScheduledEvent={false}
                    size="md"
                />
            ) : (
                <HStack>
                    <Spinner />
                    <Text variant="headingLg" style={{ whiteSpace: 'nowrap' }}>
                        BOLO
                    </Text>
                </HStack>
            )}
        </FrPageHeader>
    );
});
